import { render, staticRenderFns } from "./secondaryCard.vue?vue&type=template&id=71374359&scoped=true"
import script from "./secondaryCard.vue?vue&type=script&lang=js"
export * from "./secondaryCard.vue?vue&type=script&lang=js"
import style0 from "./secondaryCard.vue?vue&type=style&index=0&id=71374359&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71374359",
  null
  
)

export default component.exports